import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { PeriodosPageQuery, PeriodosPageQueryVariables } from './__generated__/PeriodosPageQuery';

const PERIODOS_QUERY = gql`
  query PeriodosPageQuery($descricao: String, $pagina: Int, $itens_por_pagina: Int) {
    periodos(
      filter: { descricao: $descricao, pagina: $pagina, itens_por_pagina: $itens_por_pagina }
    ) {
      id_periodo
      dsc_periodo
      dat_inicio
      dat_fim
    }
  }
`;

const usePeriodosPageQuery = (variables: PeriodosPageQueryVariables) => {
  return useQuery<PeriodosPageQuery, PeriodosPageQueryVariables>(PERIODOS_QUERY, {
    variables,
  });
};

const usePeriodosLazyQuery = () => {
  return useLazyQuery<PeriodosPageQuery, PeriodosPageQueryVariables>(PERIODOS_QUERY);
};

export { usePeriodosPageQuery, usePeriodosLazyQuery };
